import { Component, OnInit } from '@angular/core';
import { MemoryService } from 'src/app/services/memory.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: []
})
export class HomeComponent implements OnInit {
    public selectedOrganizationDisplayName: string = null;

    constructor(private memoryService: MemoryService) {}

    ngOnInit(): void {
        this.selectedOrganizationDisplayName = this.memoryService.getSelectedOrganization().name;

        this.memoryService.organizationChangeEvent.subscribe((x) => {
            if (x) {
                this.selectedOrganizationDisplayName = x.name;
            } else {
                this.selectedOrganizationDisplayName = '';
            }
        });
    }
}
